<template>
  <!-- if link = true potem renedira router-link, drugače button 
     tako je lahko komponenta uporabljena za link ali za button  -->

             <!-- dinamičo oblikovanje prek mode propsa -->
  <button v-if="!link" :class="mode">
    <slot></slot>
  </button>

  <router-link v-else :to="to" :class="mode">
    <slot></slot>
  </router-link>
</template>

<script>
// samo en slot je lahko aktiven v komponenti naenkrat
export default {
  //object oblika propsov
  props: {
      //mode prop uporabimo ko hočemo dobiti styling (css) od zunaj
    mode: {
        type: String,
        required: false,
        default: null
    },
    link: {
      type: Boolean,
      required: false,
      // by default renediramo button in ne link
      default: false,
    },
    // to=" link " ki uporabimo na router link sedaj deluje tudi na
    // base button komponenti preko propsov
    to: {
      type: String,
      required: false,
      default: '/',
    },
  },
};
</script>

<style scoped>
button,
a {
  text-decoration: none;
  padding: 0.75rem 1.5rem;
  font: inherit;
  background-color: #2D5E7A;
  border: 1px solid #2D5E7A;
  color: white;
  cursor: pointer;
  border-radius: 30px;
  margin-right: 0.5rem;
  display: inline-block;
}

a:hover,
a:active,
button:hover,
button:active {
  background-color: #2D5E7A;
  border-color: #2D5E7A;
}

 /* dinamična styla */
.flat {
  background-color: transparent;
  color: #5CC0FA;
  border: none;
}

.outline {
  background-color: transparent;
  border-color: #526C7A;
  color: #526C7A;
}

.flat:hover,
.flat:active,
.outline:hover,
.outline:active {
  background-color: #edd2ff;
}

</style>
